/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendInvitationRequest
 */
export interface ResendInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendInvitationRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the ResendInvitationRequest interface.
 */
export function instanceOfResendInvitationRequest(value: object): value is ResendInvitationRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function ResendInvitationRequestFromJSON(json: any): ResendInvitationRequest {
    return ResendInvitationRequestFromJSONTyped(json, false);
}

export function ResendInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function ResendInvitationRequestToJSON(value?: ResendInvitationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
    };
}

